<template>
    <button @click="use_coupon" type="button" class="btn btn-primary waves-effect rounded-xl" :class="w100?'w-100':''">{{ trans.use_coupon }}</button>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import {getCookie} from "../../../../../../backoffice/static/js/services/cookies";
import {mapGetters} from "vuex";
import 'whatwg-fetch';
const CURRENT_URL = location.protocol + '//' + location.host

export default {
    name: "UseCoupon",
    props: {
        id: {
            type: String,
            required: true
        },
        urlUseCoupon:{
          required:true,
          type: String
        },
        w100:{
          type:Boolean,
          default:false
        }
    },
    created(){
        this.trans = {
            use_coupon: gettext('Use Coupon')
        }
    },
    computed: {
        ...mapGetters({
            addCoupon: "coupons/addCoupon",
        }),
    },
    methods:{
        use_coupon(){
            if(this.id) {
                this.error = false
                let post = {
                    'coupon_id': this.id,
                };
                if(this.addCoupon){
                    this.addCoupon.all_coupons_hide()
                }
                this.$store.dispatch("ui/loader/show")
                fetch(this.urlUseCoupon, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': getCookie('csrftoken')
                    },
                    body: JSON.stringify(post)
                }).then(response => {
                    console.log(response)
                    if (response.ok) return response.json()
                    if (response.status == 406) {
                        return response.json().then(response => {
                            this.$store.dispatch("ui/loader/hide")
                            this.$store.dispatch("ui/lightbox/show", {
                                title: gettext('Error'),
                                body: response.msg || gettext("System error. Please try again later"),
                            })
                        })
                    }
                }).then(data => {
                    console.info(data)
                    if (data) {
                        window.location.href = CURRENT_URL + data.redirect;
                    }
                }).catch(error => {
                    this.$store.dispatch("ui/loader/hide")
                    console.error(error)
                    this.$store.dispatch("ui/lightbox/show", {
                        title: gettext('Error'),
                        body: gettext("System error. Please try again later"),
                    })
                });
            }
        },
    }
}
</script>

